/**
 * This file is generated from scripts/genIconComponents.ts. Any
 * changes should be made in that file.
 */
import { ursaColors } from "@smartsheet/design-tokens";
import React, { CSSProperties, forwardRef, Ref } from "react";
import { GeneratedIconProps } from "../../components/icon/GeneratedIconProps";
import { Icon } from "../../components/icon/Icon";
import { getUrsaIconColorVarName } from "../../components/icon/getUrsaIconColorVarName";
import SheetSummaryIcon20 from "./SheetSummaryIcon20";
import SheetSummaryIcon24 from "./SheetSummaryIcon24";

const sizeMap = {
    20: <SheetSummaryIcon20 />,
    24: <SheetSummaryIcon24 />,
};

export interface SheetSummaryIconProps extends GeneratedIconProps {
    /**
     * The size to render the icon at.
     */
    size: 20 | 24;
}

export const SheetSummaryIcon = forwardRef(
    (
        {
            // This is the default icon color.
            color = `var(${getUrsaIconColorVarName()}, ${ursaColors.neutral800})`,
            size,
            style,

            ...rest
        }: SheetSummaryIconProps,
        ref: Ref<HTMLElement>
    ) => (
        <Icon
            color={color}
            ref={ref}
            size={size}
            {...rest}
            style={
                {
                    ...style,
                } as CSSProperties
            }
        >
            {sizeMap[size]}
        </Icon>
    )
);
SheetSummaryIcon.displayName = "SheetSummaryIcon";
